import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useRemoveProjectCollaboratorMutation() {
    const { project } = useProject();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (userId: string) => {
            const res = await apiClient.removeProjectCollaborator({
                params: { projectId: project.id, userId },
            });
            if (res.status !== 200) {
                throw new Error("Failed to remove collaborator");
            }
            return res.body;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["project", project.id] });
        },
    });
}
